import React from 'react';
import * as R from 'ramda';

import './index.scss';

export default function Caption({children}) {
    if (R.isNil(children)) {
        return (
            <div className="caption">
                <div className="caption__missing">(No caption)</div>
            </div>
        );
    }

    return <div className="caption">{children}</div>;
}



// WEBPACK FOOTER //
// ./components/caption/index.js